import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useCurrencyString } from 'lib/hooks/useCurrencyString';
import { RecursiveModifierOption } from './RecursiveModifierOption';

export interface IOrderSummaryItem {
    id: string | number;
    quantity: number;
    title: string;
    cost: number;
    modifiers?: IOrderSummaryItem[];
    deleted?: boolean;
}

interface OrderSummaryItemProps {
    item: IOrderSummaryItem;
}

export const OrderSummaryItem: React.FC<OrderSummaryItemProps> = ({ item }) => {
    const getCurrencyString = useCurrencyString();
    return (
        <React.Fragment>
            <Grid
                container
                justifyContent="space-between"
                spacing={1}
                sx={{ textDecoration: item.deleted ? 'line-through' : undefined, width: '100%' }}
            >
                <Grid size={9}>
                    <Box>
                        <Typography>{`${item.quantity} x ${item.title}`}</Typography>
                    </Box>
                </Grid>
                <Grid size={3}>
                    <Box>
                        <Typography align="right">{getCurrencyString(item.cost)}</Typography>
                    </Box>
                </Grid>
            </Grid>
            <RecursiveModifierOption modifiers={item.modifiers} orderItemQuantity={item.quantity} />
        </React.Fragment>
    );
};
